import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AdminloginComponent } from '../adminlogin/adminlogin.component';
import { Router, Params } from '@angular/router';
import { SearchService } from '../search.service';
import * as firebase from 'firebase';
// import {  FirebaseListObservable } from 'angularfire2/database-deprecated';
// import { FirebaseObjectObservable } from 'angularfire2/database-deprecated';
import { 
  AngularFirestore 
} from 'angularfire2/firestore';

@Injectable({
  providedIn: 'root'
})
export class AuthadminGuard implements CanActivate {
  st;
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      console.log("SADasd")

      this.st=this.ser.ret;
      console.log(this.st)
      if(this.st=="denied" || this.st==undefined)
      {
        console.log("st")
        
        this.router.navigate(['/adminlogin'])
        // this.router.navigate(['/adminhome']);
        return false
      }
      if(this.st=="d"){
      // this.router.navigate(['/adminhome']);
        // return false;
      return true;
      }
  }

  constructor(private user:AdminloginComponent,private router: Router,private ser:SearchService) {


  //   var docRef = db.collection("adminlogin").doc("ret");

  //   docRef.ref.get().then((doc)=> {
  //       if (doc.exists) {
    
  //         this.ser.ret=doc.data().ret;
  //           console.log("Document data:", doc.data().ret);
  //       } else {
  //           // doc.data() will be undefined in this case
  //           console.log("No such document!");
  //       }
  //   }).catch(function(error) {
  //       console.log("Error getting document:", error);
  //   });

    }
}
